import { useState } from 'react';
import ChatHeader from './ChatHeader';
import ChatHistoryDrawer from './ChatHistoryDrawer';
import ImageLightbox from './ImageLightbox';
import MessageInput from './MessageInput';
import MessageThread from './MessageThread';

/**
 * The active conversation: header, thread, composer.
 *
 * Message state lives in App (via useMessages) rather than here, so switching
 * conversations never drops messages. This component is keyed by conversation
 * id, which resets only the transient UI (open lightbox, history drawer, draft).
 */
export default function ActiveChat({
  currentUser,
  conversation,
  profile,
  messages,
  threadStatus,
  threadError,
  sending,
  sendProgress,
  hasMore,
  onLoadOlder,
  onSendMessage,
  onBack,
  isFavorite,
  onToggleFavorite,
  onOpenDetails,
  partnerTyping = false,
  onTyping,
}) {
  const [lightboxSrc, setLightboxSrc] = useState(null);
  const [historyOpen, setHistoryOpen] = useState(false);

  return (
    // Header and composer are fixed-height rows; the thread between them is the
    // only scrolling element, which is what keeps the composer on screen.
    <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
      <ChatHeader
        conversation={conversation}
        currentUser={currentUser}
        profile={profile}
        onBack={onBack}
        isFavorite={isFavorite}
        onToggleFavorite={onToggleFavorite}
        onOpenHistory={() => setHistoryOpen((open) => !open)}
        historyOpen={historyOpen}
        onOpenDetails={onOpenDetails}
      />

      <MessageThread
        conversationId={conversation.id}
        participantName={conversation.name}
        messages={messages}
        status={threadStatus}
        error={threadError}
        hasMore={hasMore}
        onLoadOlder={onLoadOlder}
        onOpenImage={setLightboxSrc}
        partnerTyping={partnerTyping}
      />

      <MessageInput
        onSend={onSendMessage}
        onTyping={onTyping}
        sending={sending}
        sendProgress={sendProgress}
      />

      <ImageLightbox
        src={lightboxSrc}
        alt={`Attachment shared in the conversation with ${conversation.name}`}
        onClose={() => setLightboxSrc(null)}
      />

      <ChatHistoryDrawer
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        participantName={conversation.name}
        messages={messages}
        onOpenImage={setLightboxSrc}
      />
    </div>
  );
}
